<template>
  <div class="empty-state flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
    <p class="mb-2 md:mb-4 opacity-60">
      <component :is="iconComponent" />
    </p>
    <p class="md:text-base font-medium opacity-60">{{ message }}</p>
  </div>
</template>

<script>
/**
 * 空状态组件
 * 替代页面中重复的 inline SVG 空状态
 * @prop {String} type - 空状态类型：search | course | org | default
 * @prop {String} message - 显示文案
 */
const SearchIcon = {
  functional: true,
  render(h) {
    return h('svg', {
      attrs: {
        width: 64, height: 64, viewBox: '0 0 24 24',
        fill: 'none', stroke: 'currentColor', 'stroke-width': 1,
        'stroke-linecap': 'round', 'stroke-linejoin': 'round',
      },
    }, [
      h('circle', { attrs: { cx: 11, cy: 11, r: 8 } }),
      h('line', { attrs: { x1: 21, y1: 21, x2: 16.65, y2: 16.65 } }),
    ]);
  },
};

const EmptyBoxIcon = {
  functional: true,
  render(h) {
    return h('svg', {
      attrs: {
        width: 64, height: 64, viewBox: '0 0 24 24',
        fill: 'none', stroke: 'currentColor', 'stroke-width': 1,
        'stroke-linecap': 'round', 'stroke-linejoin': 'round',
      },
    }, [
      h('path', { attrs: { d: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' } }),
      h('polyline', { attrs: { points: '3.27 6.96 12 12.01 20.73 6.96' } }),
      h('line', { attrs: { x1: 12, y1: 22.08, x2: 12, y2: 12 } }),
    ]);
  },
};

export default {
  name: 'EmptyState',
  props: {
    type: {
      type: String,
      default: 'search',
      validator: (v) => ['search', 'course', 'org', 'default'].includes(v),
    },
    message: {
      type: String,
      default: '暂无数据',
    },
  },
  computed: {
    iconComponent() {
      const map = {
        search: SearchIcon,
        course: EmptyBoxIcon,
        org: EmptyBoxIcon,
        default: SearchIcon,
      };
      return map[this.type] || SearchIcon;
    },
  },
};
</script>

<style scoped>
.empty-state {
  padding-top: 128px;
  padding-bottom: 128px;
}

</style>
